import { omitBy, isUndefined } from "lodash";
function omitUndefined(obj) {
  return omitBy(obj, isUndefined);
}
export {
  omitUndefined
};
